export default function CTASection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
          Ready to Shop Smarter?
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-lg mx-auto leading-relaxed">
          Access 15+ categories via the official Vigorbuy store. Browse curated spreadsheets, buying guides, and QC resources — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 border border-foreground-200 text-foreground-700 rounded-full text-sm font-medium hover:border-foreground-400 transition-all whitespace-nowrap cursor-pointer"
          >
            Vigorbuy Sheet
            <i className="ri-external-link-line text-base"></i>
          </a>
        </div>

        <div className="mt-14 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20horizontal%20banner%20featuring%20elegant%20arrangement%20of%20fashion%20products%20shoes%20handbags%20watches%20and%20accessories%20in%20a%20row%20on%20warm%20oak%20surface%20soft%20natural%20lighting%20from%20large%20window%20editorial%20catalog%20style%20sophisticated%20composition%20clean%20aesthetic%20no%20text%20no%20logos&width=1400&height=300&seq=vigor-v2-cta-banner&orientation=landscape"
            alt="Vigorbuy product categories showcase"
            className="w-full h-auto rounded-2xl object-cover"
          />
        </div>
      </div>
    </section>
  );
}